import styled, { keyframes } from "styled-components";

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const RowScaler = styled.div`
  position: relative;
  width: 100%;

  &[data-density="compact"] {
    --icon: 22px;
  }

  &[data-density="micro"] {
    --icon: 20px;
  }

  &[data-density="nano"] {
    --icon: 0px;

    .icon-wrap {
      display: none;
    }

    .row-inner {
      gap: 6px !important;
    }
  }
`;

export const RowInner = styled.div`
  display: flex;
  align-items: stretch;
  gap: 10px;
  flex-wrap: nowrap;
  will-change: transform;
`;

export const StatCard = styled.div<{ $color }>`
  flex: 1 1 0;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  position: relative;
  padding: 6px;
  text-align: center;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
  animation: ${fadeUp} 280ms ease both;
  contain: paint;

  &::before {
    content: "";
    position: absolute;
    inset: 0 0 auto 0;
    height: 2px;
    border-radius: 12px 12px 0 0;
    background: ${(p) => p.$color};
    opacity: 0.5;
  }
`;

export const Icon = styled.div<{ $color: string }>`
  width: var(--icon, 28px);
  height: var(--icon, 28px);
  margin: 0 auto 6px;
  color: ${(p) => p.$color};
  display: grid;
  place-items: center;

  svg {
    width: calc(var(--icon, 28px) * 0.56);
    height: calc(var(--icon, 28px) * 0.56);
    display: block;
  }
`;

export const Count = styled.div`
  font-size: clamp(11px, 2.1vw, 20px);
  font-weight: 900;
  color: #0f172a;
  line-height: 1.1;
  margin-bottom: 3px;
`;

export const Label = styled.div`
  font-size: clamp(8px, 1.1vw, 10px);
  font-weight: 800;
  color: #64748b;
`;
